import type { TranslationMessages } from '../../types';

export const point_store: TranslationMessages = {
  title: 'Point Store',
  subtitle: 'Redeem your earned points for rewards',
  loading: 'Loading point store...',
  available_items: 'Available Items',
  categories: 'Categories',
  cash_redemption: 'Cash Redemption',
  items: 'Items',
  experiences: 'Experiences',
  gacha: 'Gacha',
  redeem: 'Redeem',
  points_cost: 'Points Cost',
  cash_value: 'Cash Value',
  stock_available: 'Stock Available',
  out_of_stock: 'Out of Stock',
  redemption_amount: 'Redemption Amount',
  minimum_redemption: 'Minimum Redemption',
  confirm_redemption: 'Confirm Redemption',
  redemption_confirmation: 'Redemption Confirmation',
  redemption_successful: 'Redemption Successful',
  insufficient_points: 'Insufficient Points',
  gacha_box: 'Gacha Box',
  draw_gacha: 'Draw Gacha',
  gacha_result: 'Gacha Result',
  congratulations: 'Congratulations!',
  you_won: 'You won',
  stats_available: 'Available',
  stats_pending: 'Pending',
  stats_total: 'Total',
  stats_lifetime: 'Lifetime',
  search_items: 'Search Items',
  search_placeholder: 'Search by name, description, or tags...',
  category_label: 'Category',
  all_categories: 'All Categories',
  popular: 'Popular',
  limited: 'Limited',
  points: 'points',
  stock_remaining: 'Stock: %{count} remaining',
  redeem_now: 'Redeem Now',
  recent_redemptions: 'Recent Redemptions',
  recent_redemptions_desc: 'Your recent point redemptions and their status',
  no_redemptions: 'No redemptions yet',
  failed_load: 'Failed to load store data',
  insufficient_for_item: 'Insufficient points for this item',
  item_out_of_stock: 'This item is out of stock',
  redeem_success: 'Successfully redeemed %{name}!',
  status_pending: 'Pending',
  status_approved: 'Approved',
  status_completed: 'Completed',
  status_cancelled: 'Cancelled',
};
